import { render } from "./AttachProductSlideOverComponent.vue?vue&type=template&id=3c9d1849"
import script from "./AttachProductSlideOverComponent.vue?vue&type=script&lang=js"
export * from "./AttachProductSlideOverComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__